import React, { useEffect, useState } from "react";
import styles from "./Offers.module.css";
import Button from "common-ui-components/components/button/Button";
import g2 from "../subscription/manage-subscription/g2-crowd-vector-logo-2022.svg";
import captera from "../subscription/manage-subscription/capterra.svg";
import star from "../subscription/manage-subscription/star.svg";
import tick from "./tick-white.svg";
import EM_API from "common-ui-components/components/utils/API";
import { notify } from "common-ui-components/components/notification/Notification";
import { Failure } from "common-ui-components/components/notification/templates";
import Success from "../../../../common-ui-components/components/notification/templates/Success";
import ResponseLoader from "common-ui-components/components/ResponseLoader/ResponseLoader";
import SkeletonLoader from "common-ui-components/components/ResponseLoader/Skeleton loading/SkeletonLoader";
import OffersLoader from "./OffersLoader";

function Offers() {
  const [g2Status, setG2Status] = useState("");
  const [capterraStatus, setCapterraStatus] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [reviewUrl, setReviewUrl] = useState("");

  useEffect(() => {
    const getOfferStatus = async () => {
      setIsLoading(true);
      try {
        const response = await EM_API.get("payment/offer-status");
        setG2Status(response.body.g2Status);
        setCapterraStatus(response.body.capterraStatus);
      } catch (e) {
        console.error(e);
      } finally {
        setIsLoading(false);
      }
    };
    getOfferStatus();
  }, []);

  const handleOfferClick = async () => {
    if (!reviewUrl) {
      notify(<Failure>Please paste a review URL to claim the offer.</Failure>);
      return;
    }
    try {
      const response = await EM_API.get(
        `payment/submit-review?reviewLink=${reviewUrl}`,
      );
      if (response.status) {
        notify(<Success>{response.message}</Success>);
        setReviewUrl("");
      } else {
        notify(<Failure>{response.message}</Failure>);
        setReviewUrl("");
      }
    } catch (e) {
      console.error(e);
      notify(<Failure>Failed to submit review. Please try again.</Failure>);
    }
  };

  const handleReview = (platform) => {
    if (platform === "g2") {
      window.open(
        "https://www.g2.com/products/zecurit/review_modalities/new",
        "_blank",
      );
    } else if (platform === "capterra") {
      window.open(
        "https://reviews.capterra.com/products/new/5a0f9274-82d8-4378-87c0-9ca1c49289d8/",
        "_blank",
      );
    }
  };

  const renderButton = (status, platform) => {
    switch (status) {
      case "Not Availed":
        return (
          <Button onClick={() => handleReview(platform)}>Write a Review</Button>
        );
      case "Pending":
        return (
          <div className={styles.infoContainer}>
            <div className={styles.pendingTickContainer}>
              <img src={tick} alt="tick" />
            </div>
            <p className={styles.text}>Awaiting Approval</p>
          </div>
        );
      case "Accepted":
        return (
          <div className={styles.infoContainer}>
            <div className={styles.claimedTickContainer}>
              <img src={tick} alt="tick" />
            </div>
            <p className={styles.text}>Offer claimed</p>
          </div>
        );
      default:
        return null;
    }
  };

  return (
    <div
      style={{
        background: "#FFFFFF",
        height: "100%",
        padding: "2.2rem 3rem",
      }}
    >
      {isLoading ? (
        // Render loader while fetching data
        // <OffersLoader />
        (<ResponseLoader />)
      ) : (
        // Render actual content after loading
        (<div className={styles.container}>
          <p className={styles.heading}>Review Us & Extend Your Trial</p>
          <p className={styles.para}>
            Leave a review and enjoy 7 extra trial days for each one.
          </p>
          <div className={styles.cards}>
            {/* G2 Card */}
            <div className={styles.card}>
              <img src={g2} alt="G2 Review" height={100} width={100} />
              <div className={styles.stars}>
                {Array.from({ length: 5 }).map((_, i) => (
                  <img key={i} src={star} alt="star" width={14} height={14} />
                ))}
              </div>
              {renderButton(g2Status, "g2")}
            </div>

            {/* Capterra Card */}
            <div className={styles.card}>
              <img
                style={{ marginTop: "-25px" }}
                src={captera}
                alt="Capterra Review"
                height={150}
                width={150}
              />
              <div style={{ marginTop: "-2.5rem" }} className={styles.stars}>
                {Array.from({ length: 5 }).map((_, i) => (
                  <img key={i} src={star} alt="star" width={14} height={14} />
                ))}
              </div>
              {renderButton(capterraStatus, "capterra")}
            </div>
          </div>
          {/* Input & Claim Offer Button */}
          {(g2Status !== "Accepted" || capterraStatus !== "Accepted") && (
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                gap: "1rem",
              }}
            >
              <input
                className={styles.input}
                placeholder="Please paste the review URL and claim offer"
                value={reviewUrl}
                onChange={(e) => setReviewUrl(e.target.value)}
              />
              <div style={{ display: "flex", justifyContent: "center" }}>
                <Button variant="primary" onClick={handleOfferClick}>
                  Claim Offer
                </Button>
              </div>
            </div>
          )}
        </div>)
      )}
    </div>
  );
}

export default Offers;
